// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blog__wrapper {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.blog__inner-width {
  width: 100%;
  height: 100%;
}

.blog__page-wrapper {
  display: flex;
  height: 100%;
}

.blog__article-section {
  display: flex;
  flex-wrap: wrap;
  height: 100vh;
  width: 70%;
}

.blog__user-mini-card {
  width: 30%;
  border: 1px solid black;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/blog/blog.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB","sourcesContent":[".blog__wrapper {\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.blog__inner-width {\n  width: 100%;\n  height: 100%;\n}\n\n.blog__page-wrapper {\n  display: flex;\n  height: 100%;\n}\n\n.blog__article-section {\n  display: flex;\n  flex-wrap: wrap;\n  height: 100vh;\n  width: 70%;\n}\n\n.blog__user-mini-card {\n  width: 30%;\n  border: 1px solid black;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
